import React from 'react';
import ChevronDownIcon from './ChevronDownIcon';

/**
 * Select / dropdown atom.
 */
export default function Select({
  value,
  onChange,
  options = [],
  placeholder = 'Select',
  className = '',
  disabled = false,
  ...props
}) {
  return (
    <div className={`ca-select ${className}`.trim()}>
      <select
        className="ca-select__control"
        value={value ?? ''}
        onChange={onChange}
        disabled={disabled}
        {...props}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((opt) => {
          const val = typeof opt === 'string' ? opt : opt.value;
          const label = typeof opt === 'string' ? opt : opt.label;
          return (
            <option key={val} value={val}>
              {label}
            </option>
          );
        })}
      </select>
      <span className="ca-select__chevron">
        <ChevronDownIcon size={16} />
      </span>
    </div>
  );
}
